import React from "react";
import { StyleSheet, Text } from "react-native";
export const Strong = ({ children, style, ...props }) => (<Text {...props} style={[styles.strong, style]}>
    {children}
  </Text>);
const styles = StyleSheet.create({
    strong: {
        fontWeight: "bold",
    },
});
//# sourceMappingURL=Strong.js.map